import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import CollectionModule from "components/collection";
import RenderModules from "helpers/render-modules";
import { useGlobalContext } from "context/global";
import { allMeals, cartMeals } from "utils/constants";
import ProductItem from "components/product/item";
import useModal from "hooks/useModal";
import extractIdFromGid from "helpers/extract-gid";
import NoMeals from "assets/images/no-meals.png";
import SubscriptionProducts from "../account/subscription/products";

const CollectionContent = ({ collections, modules, modulesBelowCollections, products }) => {
	const { translation, isSubscriptionPage } = useGlobalContext();
	const { subscriptionId } = useSelector(state => state.account.subscription);
	const { view } = useSelector(state => state.global);
	const [modal, openModal, closeModal] = useModal("product");

	useEffect(() => {
		window.scrollTo({ top: 0, behavior: "smooth" });
	}, [view]);

	return (
		<div className="w-full md:w-11/12 m-auto hd-screen-max-width px-4 lg:px-0">
			{modules && view !== cartMeals && !modulesBelowCollections && <RenderModules modules={modules} />}
			{view === allMeals && collections?.length > 0 &&
				collections.filter((c) => c.show).map((data, index) =>
					<CollectionModule key={`${data?.collection?.handle}-${index}`} data={data} />)
			}
			{view === cartMeals && (
				subscriptionId && isSubscriptionPage ?
					<div className="w-full text-center py-10 text-gray-500 mt-8">
						<SubscriptionProducts allProducts={products} isSlider={false} />
					</div> :
					products?.length > 0 ? (
						<div className="w-full py-10 mt-8 flex flex-wrap justify-center">
							{products?.map((item, index) => (
								<div id={item.id} key={`${item.id}${index}`}
									className="w-full mx-[1%] md:w-[30%] lg:w-[22%] mb-10 lg:mx-2">
									<ProductItem
										product={{ ...item, index }}
										isOpen={modal[extractIdFromGid(item.id)]}
										openModal={() => openModal(extractIdFromGid(item.id))}
										closeModal={() => closeModal(extractIdFromGid(item.id))}
										newLayout
									/>
								</div>
							))}
						</div>
					) :
						<div className="w-full text-center py-5 my-8 flex flex-col items-center justify-center">
							<img className="w-28 lg:w-36 mb-4" src={NoMeals} alt="" role="presentation" aria-hidden="true" />
							<h2>{translation.collection?.no_meals_title}</h2>
							<p className="opacity-70">{translation.collection?.no_meals_subtitle}</p>
						</div>

			)}
			{modules && view !== cartMeals && modulesBelowCollections && <RenderModules modules={modules} />}
		</div>
	);
};

export default CollectionContent;